/**
 * Best-effort brokerage team member email from API/order/project payloads.
 */
export function resolveBrokerageTeamMemberEmail(source: unknown): string {
  const o = source as Record<string, unknown> | null | undefined;
  if (!o || typeof o !== "object") return "";
  const nested = (o as { brokerage_team_member?: { email?: string } }).brokerage_team_member;
  const fromNested =
    nested && typeof nested === "object" && nested !== null
      ? String(nested.email ?? "").trim()
      : "";
  const direct = String(
    (o as { team_member_email?: string }).team_member_email ??
      (o as { brokerage_team_member_email?: string }).brokerage_team_member_email ??
      (o as { teamMemberEmail?: string }).teamMemberEmail ??
      ""
  ).trim();
  return direct || fromNested;
}

/**
 * Best-effort brokerage firm (admin / firm account) email from project payloads or search `item` rows.
 */
export function resolveBrokerageFirmEmail(source: unknown): string {
  const o = source as Record<string, unknown> | null | undefined;
  if (!o || typeof o !== "object") return "";
  const direct = String(
    (o as { brokerage_firm_email?: string }).brokerage_firm_email ??
      (o as { brokerageFirmEmail?: string }).brokerageFirmEmail ??
      (o as { firm_email?: string }).firm_email ??
      (o as { company_email?: string }).company_email ??
      ""
  ).trim();
  if (direct) return direct;
  const nested = (o as { brokerage_firm?: { email?: string } }).brokerage_firm;
  if (nested && typeof nested === "object" && nested !== null) {
    const em = String(nested.email ?? "").trim();
    if (em) return em;
  }
  const lt = String((o as { license_type?: string }).license_type ?? "").toUpperCase();
  if (lt === "BROKERAGE_FIRM") {
    const em = String((o as { email?: string }).email ?? "").trim();
    if (em) return em;
  }
  return "";
}

/**
 * Installation orders: team member is often `user_email` when `team_member_id` is set and differs from `customer_email`.
 */
export function resolveInstallationBrokerageTeamMemberEmail(order: unknown): string {
  const fromApi = resolveBrokerageTeamMemberEmail(order);
  if (fromApi) return fromApi;
  const o = order as {
    team_member_id?: string;
    user_email?: string;
    customer_email?: string;
  } | null;
  if (!o?.team_member_id) return "";
  const cust = String(o.customer_email || "").trim();
  const userEm = String(o.user_email || "").trim();
  if (!userEm) return "";
  /** No separate customer mailbox — `user_email` is the team member / order contact. */
  if (!cust) return userEm;
  if (userEm.toLowerCase() !== cust.toLowerCase()) return userEm;
  return "";
}
